/* stylelint-disable selector-no-qualifying-type */
/**
@prop --ux-file-upload-item-default-widt: Item default width
@prop --ux-file-upload-item-min-width: Item min width
@prop --ux-file-upload-item-max-Width: Items max width
@prop --ux-file-upload-spacing: Item spacing
@prop --ux-file-upload-items-per-row: Items per row
@prop --ux-file-upload-item-alignment: Item alignment
*/
.ux-file-upoad {
  display: block;
  position: relative;
}

@mixin aspect-ratio($width, $height) {
  position: relative;

  &::before {
    display: block;
    content: "";
    width: 100%;
    padding-top: calc($height / $width * 100%);
  }
}

.ux-file-upload--error {
  .ux-file-upload__container {
    border: 1px solid $color-red-error;
  }

  .ux-file-upload__add-file {
    border-color: $color-red-error;
  }

  .ux-file-upload__add-file svg {
    fill: $color-red-error;
  }
}

.ux-file-upload--disabled {
  pointer-events: none;

  .ux-file-upload__container {
    opacity: 0.2;
  }
}

.ux-label {
  @include font(bold);
  display: inline-block;
  font-size: $size-text-small;
  min-width: 0;
  text-transform: uppercase;
}

.ux-label--message {
  @include font(light);
}

.ux-label--error {
  @include font(light);

  color: $color-red-error;
}

.ux-file-upload__file-container {
  display: none;
  pointer-events: none;
}

.ux-file-upload__container {
  border: 1px solid $color-gray-borders;
  cursor: pointer;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: var(--ux-file-upload-item-alignment);
  padding: var(--ux-file-upload-spacing);
  position: relative;
  width: 100%;
}

.ux-file-upload__container--items-per-row {
  .ux-file-upload__thumbnail-container,
  .ux-file-upload__action-container {
    width: calc(100% / var(--ux-file-upload-items-per-row) - 30px);
  }
}

.ux-file-upload__container--bulk-delete {
  .ux-file-upload__add-file--with-thumbnails {
    width: 50%;
    margin-right: var(--ux-file-upload-spacing);
  }

  .ux-file-upload__delete-all {
    width: 50%;
    margin-left: var(--ux-file-upload-spacing);
  }
}

.ux-file-upload__container:hover {
  border: 1px solid $color-green;
}

.ux-file-upload__thumbnail-container {
  width: var(--ux-file-upload-item-default-width);
  min-width: var(--ux-file-upload-item-min-width);
  max-width: var(--ux-file-upload-item-max-width);
  margin: var(--ux-file-upload-spacing);
  position: relative;
  @include aspect-ratio(16,9);
}

.ux-file-upload__action-container {
  width: var(--ux-file-upload-item-default-width);
  min-width: var(--ux-file-upload-item-min-width);
  max-width: var(--ux-file-upload-item-max-width);
  margin: var(--ux-file-upload-spacing);
  position: relative;
  @include aspect-ratio(16,9);
}

.ux-file-upload__action-container-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  position: absolute;
}

.ux-file-upload__add-file {
  width: 100%;
  height: 100%;
  align-items: center;
  border: 1px dashed $color-black;
  display: flex;
  justify-content: center;
  pointer-events: none;
  position: relative;
  transition: all 0.3s ease-in-out;

  .ux-icon {
    font-size: 12px;
    margin: 0;
    transform: rotate(45deg);
    transition: transform 0.1s ease-in-out;
  }
}

.ux-file-upload__delete-all {
  width: 100%;
  height: 100%;
  padding: 0;
  align-items: center;
  background-color: $color-white;
  border: 1px dashed $color-black;
  cursor: pointer;
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 1;

  .ux-icon {
    font-size: 18px;
  }
}

.ux-file-upload__label {
  cursor: pointer;
  height: 100%;
  left: 0;
  right: 0;
  top: 0;
  width: 100%;
  position: absolute;
}

.ux-file-upload__input-field {
  clip: rect(1px, 1px, 1px, 1px);
  height: 1px;
  overflow: hidden;
  position: absolute !important;
  width: 1px;
}
